var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.875C2 18.5712 2.27656 19.2389 2.76884 19.7312C3.26113 20.2234 3.92881 20.5 4.625 20.5H20.375C21.0712 20.5 21.7389 20.2234 22.2312 19.7312C22.7234 19.2389 23 18.5712 23 17.875V10.6562H2V17.875ZM5.09375 14.3125C5.09375 13.9395 5.24191 13.5819 5.50563 13.3181C5.76935 13.0544 6.12704 12.9062 6.5 12.9062H8.75C9.12296 12.9062 9.48065 13.0544 9.74437 13.3181C10.0081 13.5819 10.1562 13.9395 10.1562 14.3125V15.25C10.1562 15.623 10.0081 15.9806 9.74437 16.2444C9.48065 16.5081 9.12296 16.6562 8.75 16.6562H6.5C6.12704 16.6562 5.76935 16.5081 5.50563 16.2444C5.24191 15.9806 5.09375 15.623 5.09375 15.25V14.3125ZM20.375 4H4.625C3.92881 4 3.26113 4.27656 2.76884 4.76884C2.27656 5.26113 2 5.92881 2 6.625V7.84375H23V6.625C23 5.92881 22.7234 5.26113 22.2312 4.76884C21.7389 4.27656 21.0712 4 20.375 4V4Z",
    fill: "#CA5050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardd);
export default __webpack_public_path__ + "static/media/cardd.7b5f7e71f68477506cc7a792b2233e48.svg";
export { ForwardRef as ReactComponent };